<template>
  <a :href="`/profile/${connection.UID}`" class="connection">
    <div>
      <ik-image
        loading="lazy"
        :transformation="[{ height: 500, width: 500 }]"
        v-if="connection.url"
        :src="connection.url"
        class="image"
      />
      <div v-else class="image smallBorder">
        <IconBase
          icon-name="profile"
          iconColor="#444"
          viewBox="0 0 32 32"
          width="100%"
          height="100%"
          strokeWidth="0px"
          ><IconProfileImg
        /></IconBase>
      </div>
    </div>
    <div class="displayName">{{ connection.name }}</div>
    <div class="displayName connectedDate">{{ connectionDateString }}</div>
  </a>
</template>

<script>
import IconBase from "../../../components/IconBase";
import IconProfileImg from "../../../components/SVG/IconProfileImg";

import { formatConnectionDate } from "../../../utilities/dateFormatter";

export default {
  name: "Connection",
  props: {
    connection: Object,
    statusType: String
  },
  components: {
    IconBase,
    IconProfileImg,
  },
  computed: {
    connectionDateString() {
      let status = "";
      if (this.statusType === "connected") 
        status = "Connected: ";
      else if (this.statusType === "received")
        status = "Request received: ";
      else if (this.statusType === "sent")
        status = "Request sent: ";
      return status + formatConnectionDate(this.connection.dateMS);
    }
  }
};
</script>